import axios, { AxiosPromise } from 'axios';

export const getSettings = (): AxiosPromise<any> =>
  axios.get('/admin/fale-conosco');
